import { Button } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { buildE2nApiTitle } from '../lib/buildE2nApiTitle';
import { useE2nApiAuth } from '../lib/E2nApiAuthContext';
import { useManager } from '../lib/useManager';

export function E2nApiOverviewPage() {
  const { t } = useTranslation();
  const { user, standort } = useE2nApiAuth();
  const { manager, loading, error } = useManager();

  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold">{buildE2nApiTitle()}</h1>
      {user && (
        <p className="mt-2">
          {t('domain.e2nApi.overview.loggedInAs', { username: user.username })}
        </p>
      )}
      <p className="mt-1">
        {t('domain.e2nApi.overview.standort', { standort: standort.name })}
      </p>
      {loading && (
        <p className="mt-4">{t('domain.e2nApi.overview.managerLoading')}</p>
      )}
      {error && (
        <p className="mt-4">{t('domain.e2nApi.overview.managerError')}</p>
      )}
      {manager && (
        <p className="mt-4">
          {t('domain.e2nApi.overview.managerInfo', {
            vorname: manager.vorname,
            nachname: manager.nachname,
            email: manager.email,
          })}
        </p>
      )}
      <Button className="mt-4">
        {t('domain.e2nApi.overview.placeholderButton')}
      </Button>
    </div>
  );
}
